import { isoTimeToDate } from "./isoTimeToDate";

export const dateObjectToIsoDate = (date: Date): string =>
	isoTimeToDate(date.toISOString());
